module.exports = __webpack_public_path__ + "static/media/5-b_old.00702f22.png";